export default {
  computed: {
    isProductPreviewMode() {
      return _.get(this.$route, 'query.preview') === '1';
    },
  },
};
